import { ErrorMessage } from './ErrorMessage';
import { IValidator } from './IValidator';

export const validateForm = <T>(validators: IValidator<T>[], state: T): ErrorMessage[] =>
  validators
    .filter(validator => !validator.rule(state))
    .map(({ errorMessage, inputIds }) => ({
      errorMessage,
      inputIds,
    }));
